export default "__VITE_PUBLIC_ASSET__948d2879__"